import { apiClient } from '@/api/client';
import type { Profile } from '@/types';

export interface CreateProfileInput {
  userName: string;
  description?: string;
  explicit_tags?: string[];
}

export interface UpdateProfileInput {
  description?: string;
  explicit_tags?: string[];
  blocked?: {
    tags?: string[];
    authors?: string[];
    sources?: string[];
  };
  // Campos do perfil (salvos em user_profile.preferences)
  gender?: string;
  profileTypes?: string[];
  // Campos do usuário (salvos na tabela user)
  userName?: string; // -> user.name
  role?: string; // Job title -> user.title
  industry?: string; // -> user.industry
}

const PROFILE_ID_KEY = 'banquinha_profile_id';

export const profileService = {
  // Hermes: GET /profiles
  async getProfiles(): Promise<Profile[]> {
    try {
      return await apiClient.get<Profile[]>('/profiles');
    } catch {
      return [];
    }
  },

  // Hermes: GET /profiles (retorna o primeiro e salva no localStorage)
  async getProfile(): Promise<Profile | null> {
    try {
      const profiles = await apiClient.get<Profile[]>('/profiles');
      const profile = profiles.length > 0 ? profiles[0] : null;
      if (profile) {
        localStorage.setItem(PROFILE_ID_KEY, profile.id);
      }
      return profile;
    } catch {
      return null;
    }
  },

  // Hermes: POST /profiles (salva o ID no localStorage)
  async createProfile(data: CreateProfileInput): Promise<Profile> {
    const profile = await apiClient.post<Profile>('/profiles', data);
    localStorage.setItem(PROFILE_ID_KEY, profile.id);
    return profile;
  },

  // Hermes: PUT /profiles/:id
  async updateProfile(id: string, data: UpdateProfileInput): Promise<Profile> {
    return apiClient.put<Profile>(`/profiles/${id}`, data);
  },

  // Hermes: PUT /profiles/:id
  async completeOnboarding(id: string): Promise<Profile> {
    return apiClient.put<Profile>(`/profiles/${id}`, { onboardingCompleted: true });
  },
};
